import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useMemo, useState } from 'react';
import { StorageClient } from '@atlaskit/frontend-utilities/storage-client';

// THIS HAS BEEN TEMPORARILY COPIED FROM '@atlaskit/frontend-utilities'
// jira-frontend has pinned @atlaskit/frontend-utilities to a version that does not have the hook due to a HOT
// See https://hello.atlassian.net/browse/WP-222

export var useLocalStorage = function useLocalStorage(key, defaultValue) {
  var storageClient = useMemo(function () {
    return new StorageClient(key);
  }, [key]);
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    var _ref;
    var loadedValue = (_ref = storageClient.getItem(key)) !== null && _ref !== void 0 ? _ref : undefined;
    if (loadedValue !== undefined) {
      setValue(loadedValue);
    }
  }, [key, storageClient]);
  useEffect(function () {
    storageClient.setItemWithExpiry(key, value);
  }, [key, storageClient, value]);
  return [value, setValue];
};